<template>
  <svg aria-hidden="true" :class="className">
    <use :xlink:href="iconHref" />
  </svg>
</template>
<script>

export default {
  props: {
    name: {
      required: true,
      type: String
    },
    className: {
      required: false,
      type: String
    }
  },
  computed: {
    iconHref() {
      return `#icon-${this.name}`;
    }
  },
  created() {
    // import(`@/assets/images/${this.$region}/svgs/${this.name}.svg`);
    require(`@/assets/images/${this.$region}/svgs/${this.name}.svg`);
  }
};
</script>